module.exports = {
  title: '自营店铺管理',
  route: {
    path: '/user-manage',
    children: {
      path: 'proprietary-store-setzone',
    },
  },
};
